 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER1ONTHEEVEOFMARRIAGE from '@/components/0_chapter1ontheeveofmarriage'
 import A_CHAPTER2BUYAWEDDINGRING from '@/components/1_chapter2buyaweddingring'
 import A_CHAPTER3OATHCOLLAPSE from '@/components/2_chapter3oathcollapse'
 import A_CHAPTER4LEFTHANDS from '@/components/3_chapter4lefthands'
 import A_CHAPTER5NOCOMPLAINTSNOREGRETS from '@/components/4_chapter5nocomplaintsnoregrets'
 import A_CHAPTER6LANGUANGCONTINENT from '@/components/5_chapter6languangcontinent'
 import A_CHAPTER7LASTWORDS from '@/components/6_chapter7lastwords'
 import A_CHAPTER8COMEOUTANDSEEME from '@/components/7_chapter8comeoutandseeme'
 import A_CHAPTER9KILLINGADOLPHIN from '@/components/8_chapter9killingadolphin'
 import A_CHAPTER10HUMANANDGODANGER from '@/components/9_chapter10humanandgodanger'
 import A0_CHAPTER11ANGERINCINERATESTHEHEAVENS from '@/components/10_chapter11angerincineratestheheavens'
 import A1_CHAPTER12ANCIENTFORBIDDENSKY from '@/components/11_chapter12ancientforbiddensky'
 import A2_CHAPTER13PURGATORYSTAFF from '@/components/12_chapter13purgatorystaff'
 import A3_CHAPTER14MISCHIEF from '@/components/13_chapter14mischief'
 import A4_CHAPTER15MYNAMEISFALLINGHEAVEN from '@/components/14_chapter15mynameisfallingheaven'
 import A5_CHAPTER16FATECHANGE from '@/components/15_chapter16fatechange'
 import A6_CHAPTER17IFYOUDONTSOUNDTHEBELLYOUWILLBEFINE from '@/components/16_chapter17ifyoudontsoundthebellyouwillbefine'
 import A7_CHAPTER18BANDITINTERCEPTION from '@/components/17_chapter18banditinterception'
 import A8_CHAPTER19ELEMENTALFAIRY from '@/components/18_chapter19elementalfairy'
 import A9_CHAPTER20THEFIVEMAJORSECTS from '@/components/19_chapter20thefivemajorsects'
 import A0_CHAPTER21THREEGREATFORBIDDENAREAS from '@/components/20_chapter21threegreatforbiddenareas'
 import A1_CHAPTER22UNBELIEVABLE from '@/components/21_chapter22unbelievable'
 import A2_CHAPTER23SKYFANTASIAACADEMY from '@/components/22_chapter23skyfantasiaacademy'
 import A3_CHAPTER24TIBETANDRAGONCROUCHINGTIGER from '@/components/23_chapter24tibetandragoncrouchingtiger'
 import A4_CHAPTER25DEANOFTHECOLLEGE from '@/components/24_chapter25deanofthecollege'
 import A5_CHAPTER26PRESIDENTOFSKYFANTASIA from '@/components/25_chapter26presidentofskyfantasia'
 import A6_CHAPTER27BARGAINING from '@/components/26_chapter27bargaining'
 import A7_CHAPTER28ARISTOCRATICOFFSPRING from '@/components/27_chapter28aristocraticoffspring'
 import A8_CHAPTER29NEWBORNCALF from '@/components/28_chapter29newborncalf'
 import A9_CHAPTER30REMEMBRANCEOFLIFE from '@/components/29_chapter30remembranceoflife'
 import A0_CHAPTER31BLUEGREATBEAUTY from '@/components/30_chapter31bluegreatbeauty'
 import A1_CHAPTER32MASSTARGETED from '@/components/31_chapter32masstargeted'
 import A2_CHAPTER33TRAININGBOTTLENECK from '@/components/32_chapter33trainingbottleneck'
 import A3_CHAPTER34NINEPOINTEDSTARMAP from '@/components/33_chapter34ninepointedstarmap'
 import A4_CHAPTER35EXTREMEDEPRESSION from '@/components/34_chapter35extremedepression'
 import A5_CHAPTER36QUICKSANDTECHNIQUE from '@/components/35_chapter36quicksandtechnique'
 import A6_CHAPTER37EARTHSTYLEMAGIC from '@/components/36_chapter37earthstylemagic'
 import A7_CHAPTER38SYSTEMATICLEARNING from '@/components/37_chapter38systematiclearning'
 import A8_CHAPTER39THEYWANTEDTOCAPTUREHIMBUTTHEYDIDNTDOSO from '@/components/38_chapter39theywantedtocapturehimbuttheydidntdoso'
 import A9_CHAPTER40PURGATORYSTAFFEXITING from '@/components/39_chapter40purgatorystaffexiting'
 import A0_CHAPTER41DARKSPELL from '@/components/40_chapter41darkspell'
 import A1_CHAPTER42DARKWAND from '@/components/41_chapter42darkwand'
 import A2_CHAPTER43ABSOLUTEGRAVITY from '@/components/42_chapter43absolutegravity'
 import A3_CHAPTER44INNOCENTBEAUTY from '@/components/43_chapter44innocentbeauty'
 import A4_CHAPTER45DEMONESS from '@/components/44_chapter45demoness'
 import A5_CHAPTER46HONOREDEXTREMELY from '@/components/45_chapter46honoredextremely'
 import A6_CHAPTER47UNCLEAREXPLANATION from '@/components/46_chapter47unclearexplanation'
 import A7_CHAPTER48ENEMIESHAVEANARROWROAD from '@/components/47_chapter48enemieshaveanarrowroad'
 import A8_CHAPTER49INTERFERENCEWITHGOODTHINGS from '@/components/48_chapter49interferencewithgoodthings'
 import A9_CHAPTER50STAYINTHEBACKMOUNTAINS from '@/components/49_chapter50stayinthebackmountains'
 import A0_CHAPTER51LIFEORDEATHCRISIS from '@/components/50_chapter51lifeordeathcrisis'
 import A1_CHAPTER52PARANOIA from '@/components/51_chapter52paranoia'
 import A2_CHAPTER53ENDLESSCAVITY from '@/components/52_chapter53endlesscavity'
 import A3_CHAPTER54TOOMUCHNONSENSE from '@/components/53_chapter54toomuchnonsense'
 import A4_CHAPTER55EERIEBLACKFOG from '@/components/54_chapter55eerieblackfog'
 import A5_CHAPTER56UNDEADREAPPEARANCE from '@/components/55_chapter56undeadreappearance'
 import A6_CHAPTER57BEAUTYCARE from '@/components/56_chapter57beautycare'
 import A7_CHAPTER58GOODHEART from '@/components/57_chapter58goodheart'
 import A8_CHAPTER59FANTASY from '@/components/58_chapter59fantasy'
 import A9_CHAPTER60FORBIDDENSPELL from '@/components/59_chapter60forbiddenspell'
 import A0_CHAPTER61GROWRICH from '@/components/60_chapter61growrich'
 import A1_CHAPTER62TRAININGTHROUGHTHENIGHT from '@/components/61_chapter62trainingthroughthenight'
 import A2_CHAPTER63ANGERFLASHES from '@/components/62_chapter63angerflashes'
 import A3_CHAPTER64THEODDSHAVECHANGED from '@/components/63_chapter64theoddshavechanged'
 import A4_CHAPTER65EXCITED from '@/components/64_chapter65excited'
 import A5_CHAPTER66BEAUTIFULWOMENINARMS from '@/components/65_chapter66beautifulwomeninarms'
 import A6_CHAPTER67TWOWORLDS from '@/components/66_chapter67twoworlds'
 import A7_CHAPTER68PLAYTHEPIGTOEATTHETIGER from '@/components/67_chapter68playthepigtoeatthetiger'
 import A8_CHAPTER69TAKEAJOKESERIOUSLY from '@/components/68_chapter69takeajokeseriously'
 import A9_CHAPTER70MAKESCROLL from '@/components/69_chapter70makescroll'
 import A0_CHAPTER71RELATIONSHIPWARMING from '@/components/70_chapter71relationshipwarming'
 import A1_CHAPTER72ORALBULLYING from '@/components/71_chapter72oralbullying'
 import A2_CHAPTER73YEARENDEXAMINATION from '@/components/72_chapter73yearendexamination'
 import A3_CHAPTER74ENERGYTRANSFER from '@/components/73_chapter74energytransfer'
 import A4_CHAPTER75COMPLETEASSESSMENT from '@/components/74_chapter75completeassessment'
 import A5_CHAPTER76YEARENDBALL from '@/components/75_chapter76yearendball'
 import A6_CHAPTER77VERBALPROVOCATION from '@/components/76_chapter77verbalprovocation'
 import A7_CHAPTER78MATCHLIST from '@/components/77_chapter78matchlist'
 import A8_CHAPTER79BLOODACCELERATION from '@/components/78_chapter79bloodacceleration'
 import A9_CHAPTER80RETURNOFDEPARTURE from '@/components/79_chapter80returnofdeparture'
 import A0_CHAPTER81SNEAKINGIN from '@/components/80_chapter81sneakingin'
 import A1_CHAPTER82FORCEDHEAVENDEFYING from '@/components/81_chapter82forcedheavendefying'
 import A2_CHAPTER83SEVENGREATFAMILIES from '@/components/82_chapter83sevengreatfamilies'
 import A3_CHAPTER84GETOUTOFHERE from '@/components/83_chapter84getoutofhere'
 import A4_CHAPTER85TIMEFLIES from '@/components/84_chapter85timeflies'
 import A5_CHAPTER86IAMLATE from '@/components/85_chapter86iamlate'
 import A6_CHAPTER87EXTREMELYARROGANT from '@/components/86_chapter87extremelyarrogant'
 import A7_CHAPTER88NIGHTCRAZY from '@/components/87_chapter88nightcrazy'
 import A8_CHAPTER89BEAUTIFULACCOMPANYING from '@/components/88_chapter89beautifulaccompanying'
 import A9_CHAPTER90THEWORLDHASCHANGED from '@/components/89_chapter90theworldhaschanged'
 import A0_CHAPTER91THISISHALLUCINATION from '@/components/90_chapter91thisishallucination'
 import A1_CHAPTER92MYSTERY from '@/components/91_chapter92mystery'
 import A2_CHAPTER93WELCOMETOTHE from '@/components/92_chapter93welcometothe'
 import A3_CHAPTER94MATCHSTART from '@/components/93_chapter94matchstart'
 import A4_CHAPTER95BEGINNINGVICTORY from '@/components/94_chapter95beginningvictory'
 import A5_CHAPTER96SARCASTICPROVOCATION from '@/components/95_chapter96sarcasticprovocation'
 import A6_CHAPTER97UNBELIEVABLEUNBELIEVABLE from '@/components/96_chapter97unbelievableunbelievable'
 import A7_CHAPTER98UNEXPECTED from '@/components/97_chapter98unexpected'
 import A8_CHAPTER99ECSTASY from '@/components/98_chapter99ecstasy'
 import A9_CHAPTER100ENDLESSRESENTMENT from '@/components/99_chapter100endlessresentment'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter1ontheeveofmarriage",
 			"name" : "0_chapter1ontheeveofmarriage",
 			"component" : A_CHAPTER1ONTHEEVEOFMARRIAGE
 		},
 		{
 			"path" : "/1_chapter2buyaweddingring",
 			"name" : "1_chapter2buyaweddingring",
 			"component" : A_CHAPTER2BUYAWEDDINGRING
 		},
 		{
 			"path" : "/2_chapter3oathcollapse",
 			"name" : "2_chapter3oathcollapse",
 			"component" : A_CHAPTER3OATHCOLLAPSE
 		},
 		{
 			"path" : "/3_chapter4lefthands",
 			"name" : "3_chapter4lefthands",
 			"component" : A_CHAPTER4LEFTHANDS
 		},
 		{
 			"path" : "/4_chapter5nocomplaintsnoregrets",
 			"name" : "4_chapter5nocomplaintsnoregrets",
 			"component" : A_CHAPTER5NOCOMPLAINTSNOREGRETS
 		},
 		{
 			"path" : "/5_chapter6languangcontinent",
 			"name" : "5_chapter6languangcontinent",
 			"component" : A_CHAPTER6LANGUANGCONTINENT
 		},
 		{
 			"path" : "/6_chapter7lastwords",
 			"name" : "6_chapter7lastwords",
 			"component" : A_CHAPTER7LASTWORDS
 		},
 		{
 			"path" : "/7_chapter8comeoutandseeme",
 			"name" : "7_chapter8comeoutandseeme",
 			"component" : A_CHAPTER8COMEOUTANDSEEME
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js